enum ControlIconType {
  CHEVRON = 'chevron',
  ARITH = 'arithmetic',
}

enum KeyConstants {
  ENTER = 'Enter',
  SPACE = 'Space',
}

enum FontSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

enum AccordionStyle {
  DEFAULT = 'default',
  STEPPED = 'stepped',
}
enum AccordionStatus {
  INCOMPLETE = 'incomplete-step',
  COMPLETE = 'complete-step',
}
enum AccordionType {
  DEFAULT = 'default',
  COMPACT = 'compact',
}
enum BorderDesign {
  TOP_BORDER = 'top-border',
  BOTTOM_BORDER = 'bottom-border',
  TOP_BOTTOM_BORDER = 'top-bottom-border',
}

export { ControlIconType, KeyConstants, FontSize, AccordionStyle, BorderDesign, AccordionStatus, AccordionType };
